import { InputField } from "./InputFields.style";

import React from "react";

interface AboutFieldProps {
  value: string;
  label: string;
  onChange: (field: string, value: string) => void;
}

export const AboutField: React.FC<AboutFieldProps> = ({
  value,
  label,
  onChange,
}) => {
  const aboutTextLength = value?.length || 0;
  return (
    <InputField
      fullWidth
      id="outlined-multiline-static"
      label={label}
      multiline
      rows={4}
      value={value}
      onChange={event => onChange("about", event.target.value)}
      slotProps={{
        htmlInput: { "data-testid": "about", maxLength: 3000 },
        formHelperText: {
          sx: {
            textAlign: "right",
            marginRight: 0,
            fontSize: 11,
          },
        },
      }}
      helperText={`${aboutTextLength} / 3000`}
    />
  );
};
